import React from 'react';
import styled, { css } from 'styled-components';
import { useRecoilValue } from 'recoil';
import { isEmpty } from 'lodash';

import { DataModificationsModal, type DataModificationsCategory } from '../../../../modals/data-modifications-modal';
import { useModal } from 'venn-utils';
import { isReportState } from 'venn-state';

import { Block, useHasVennModificationsSymbol } from '../../core';
import { getAppTitle } from 'venn-ui-kit';

interface DataModificationsButtonProps {
  modifications: DataModificationsCategory[];
}

export const DataModificationsButton = ({ modifications }: DataModificationsButtonProps) => {
  const [isOpen, open, close] = useModal();
  const isReport = useRecoilValue(isReportState);
  const vennModifiedDataSymbol = useHasVennModificationsSymbol();

  if (isEmpty(modifications)) {
    return null;
  }

  return (
    <>
      <Button isReport={isReport} onClick={open}>
        <Block.MetadataItem iconType="info-circle">
          Contains {getAppTitle()}-Modified Data&nbsp;{isReport ? <sup>{vennModifiedDataSymbol}</sup> : ''}
        </Block.MetadataItem>
      </Button>
      {isOpen && <DataModificationsModal onClose={close} modifications={modifications} />}
    </>
  );
};

const Button = styled.button<{ isReport: boolean }>`
  color: unset;
  ${(props) =>
    props.isReport &&
    css`
      pointer-events: none;
    `};
`;
